import {
	Flex,
	Icon,
	IconProps,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Text,
} from '@chakra-ui/react';
import CheckTable from 'components/dataTables/CheckTable';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { useContext, useEffect, useMemo } from 'react';

import { URL_CT360, URL_FALE_CONOSCO } from '../../utils/consts/global';
import { ButtonComponent } from '../buttons/ButtonComponent';

const CheckTableModal = ({
	filterModule,
	isOpen,
	onClose,
	columnsData,
	modalTitle,
	modalIcon = undefined,
	modalIconColor = undefined,
	modalTitleColor = undefined,
	renderRow,
	simpleDelete,
	deleteMany,
	deleteAll,
	queriesToInvalidadeOnRemove,
	queriesToInvalidadeOnEdit,
	showCreateButton = false,
	createButtonText = 'Cadastrar',
	onCreateClick = undefined,
}) => {
	const { setters } = useContext(SidebarHelpContext);

	const { setDataSidebar } = setters;

	const tableColumns = useMemo(() => columnsData, [columnsData]);

	const helpMarket: ISidebarHelp = useMemo(
		() => ({
			title: modalTitle,
			firstParagraph: `Nesta tela é possível visualizar ${modalTitle}, refletindo a organização comercial do seu negócio, contendo todos os níveis de iteração.`,
			secondParagraph: '',
			firstLink: URL_CT360,
			secondLink: URL_FALE_CONOSCO,
		}),
		[modalTitle]
	);

	const dataDelete = useMemo(() => simpleDelete, [simpleDelete]);

	const deleteMessage = useMemo(() => deleteMany, [deleteMany]);

	const dataDeleteAll = useMemo(() => deleteAll, [deleteAll]);

	useEffect(() => {
		setDataSidebar(helpMarket);
	}, [helpMarket, setDataSidebar]);

	const renderTable = (): JSX.Element => {
		return (
			<CheckTable
				module={filterModule}
				columnsData={tableColumns}
				dataDelete={dataDelete}
				filterModule={filterModule}
				renderRow={renderRow}
				deleteMessage={deleteMessage}
				bulkDeleteProps={dataDeleteAll}
				showGenericSearchInput={false}
				queriesToInvalidadeOnRemove={queriesToInvalidadeOnRemove}
				queriesToInvalidadeOnEdit={queriesToInvalidadeOnEdit}
				renderedInModal={true}
			/>
		);
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			onEsc={onClose}
			size='6xl'
			isCentered
		>
			<ModalOverlay />
			<ModalContent
				borderRadius={20}
				pt='20px'
				maxH='90%'
				overflow='hidden'
			>
				<ModalHeader>
					<Flex
						direction='column'
						align='start'
						gap={3}
					>
						{modalIcon ? (
							<Icon
								as={modalIcon as React.ComponentType<IconProps>}
								boxSize={8}
								color={modalIconColor}
							/>
						) : null}
						<Text
							fontSize='24px'
							fontWeight='bold'
							color={modalTitleColor}
						>
							{modalTitle}
						</Text>
					</Flex>

					{showCreateButton && (
						<Flex
							justify='flex-end'
							mt={4}
						>
							<ButtonComponent
								type='primary'
								title={createButtonText}
								onClick={onCreateClick}
							/>
						</Flex>
					)}
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody
					maxH='100%'
					overflow='auto'
				>
					<Flex
						direction='column'
						pt={{ sm: '120px', lg: '80px' }}
					>
						{renderTable()}
					</Flex>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export default CheckTableModal;
